import React from 'react';

const SearchFilterBar = ({
    searchTerm,
    setSearchTerm,
    yearFilter,
    setYearFilter,
    monthFilter,
    setMonthFilter,
    statusFilter,
    setStatusFilter,
    yearOptions,
    monthOptions,
    statusOptions,
    fetchPayrolls,
    canExportPayrolls,
    canAddPayroll,
    handleAdd
}) => {
    return (
        <div className="row mb-4">
            <div className="col-12">
                <div className="card shadow-sm border-0">
                    <div className="card-body">
                        <div className="row g-3 align-items-center">
                            <div className="col-md-3">
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-search text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0"
                                        placeholder="Search payrolls..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    {searchTerm && (
                                        <button
                                            className="btn btn-outline-secondary border-start-0"
                                            onClick={() => setSearchTerm('')}
                                        >
                                            <i className="bi bi-x"></i>
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="col-md-2">
                                <select
                                    className="form-select"
                                    value={yearFilter}
                                    onChange={(e) => setYearFilter(e.target.value)}
                                >
                                    {yearOptions.map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-2">
                                <select
                                    className="form-select"
                                    value={monthFilter}
                                    onChange={(e) => setMonthFilter(e.target.value)}
                                >
                                    {monthOptions.map(month => (
                                        <option key={month.value} value={month.value}>{month.label}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-2">
                                <select
                                    className="form-select"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    {statusOptions.map(status => (
                                        <option key={status.value} value={status.value}>{status.label}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-3 text-end">
                                <div className="d-flex justify-content-end align-items-center">
                                    <button
                                        className="btn btn-outline-secondary me-2"
                                        onClick={fetchPayrolls}
                                        title="Refresh"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i>
                                    </button>
                                    {canExportPayrolls && (
                                        <button
                                            className="btn btn-outline-success me-2"
                                            onClick={() => alert('Export functionality coming soon!')}
                                            title="Export Payrolls"
                                        >
                                            <i className="bi bi-download"></i>
                                        </button>
                                    )}
                                    {canAddPayroll && (
                                        <button
                                            className="btn btn-primary text-white"
                                            onClick={handleAdd}
                                        >
                                            <i className="bi bi-plus-circle me-2"></i>
                                            Add Payroll
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchFilterBar;